import { render } from "./HeroiconsSolidFolder.vue?vue&type=template&id=71572aca"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFolder.vue"]])

export default __exports__